export const LINK_SEE_ALL = 'Voir tout';
